import { initAccordion } from '../../objects/accordion/accordion';
import { CLASS_ACTIVE, CLASS_INITIALISED } from '../../tools/constants/classes';

// Selectors
const SELECTOR_CONTAINER = '[data-product-results]';
const SELECTOR_ACCORDION = '[data-accordion-container]';
const SELECTOR_IMAGE_SLIDER = '[data-before-after-image-container]';
const SELECTOR_ACCORDION_SLIDE = '[data-accordion-slide]';
const SELECTOR_TAB = '[data-results-tab]';
const SELECTOR_DESCRIPTION = '[data-results-description]';

const ATTR_INDEX = 'data-results-index';

document
  .querySelectorAll<HTMLElement>(SELECTOR_CONTAINER)
  .forEach((containerElement) => {
    // Check if section has already been initialized
    if (containerElement.classList.contains(CLASS_INITIALISED)) return;
    containerElement.classList.add(CLASS_INITIALISED);

    const accordionContainer =
      containerElement.querySelector<HTMLDetailsElement>(SELECTOR_ACCORDION);
    const slides = containerElement.querySelectorAll<HTMLDetailsElement>(
      SELECTOR_ACCORDION_SLIDE
    );
    const tabs = containerElement.querySelectorAll<HTMLElement>(SELECTOR_TAB);
    const imageSliders = containerElement.querySelectorAll<HTMLElement>(
      SELECTOR_IMAGE_SLIDER
    );
    const descriptions =
      containerElement.querySelectorAll<HTMLElement>(SELECTOR_DESCRIPTION);

    if (!accordionContainer || !slides || !tabs || !descriptions) return;

    // Initialize accordion
    initAccordion({ container: accordionContainer });

    // Hide/show sliders and descriptions based on tab clicks
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabIndex = tab.getAttribute(ATTR_INDEX);

        tabs.forEach((tab) => tab.classList.remove(CLASS_ACTIVE));

        // Add active class to clicked tab
        tab.classList.add(CLASS_ACTIVE);

        imageSliders.forEach((slider) => {
          const sliderIndex = slider.getAttribute(ATTR_INDEX);
          slider.classList.remove(CLASS_ACTIVE);

          // If tab index matches slider index, show that slider
          if (tabIndex === sliderIndex) slider.classList.add(CLASS_ACTIVE);
        });

        // If tab index matches description index, show that slider
        descriptions.forEach((desc) => {
          const descIndex = desc.getAttribute(ATTR_INDEX);
          desc.classList.remove(CLASS_ACTIVE);
          if (tabIndex === descIndex) desc.classList.add(CLASS_ACTIVE);
        });
      });
    });

    // Hide/show sliders and descriptions based on tab clicks
    slides.forEach((slide, i) => {
      if (i === 0) slide.setAttribute('open', 'open');

      slide.addEventListener('click', () => {
        const slideIndex = slide.getAttribute(ATTR_INDEX);

        slides.forEach((tab) => tab.classList.remove(CLASS_ACTIVE));

        // Add active class to clicked tab
        slide.classList.add(CLASS_ACTIVE);

        imageSliders.forEach((slider) => {
          const sliderIndex = slider.getAttribute(ATTR_INDEX);
          slider.classList.remove(CLASS_ACTIVE);

          // If tab index matches slider index, show that slider
          if (slideIndex === sliderIndex) slider.classList.add(CLASS_ACTIVE);
        });
      });
    });
  });
